module.exports = __webpack_public_path__ + "static/media/01.fa21ea3a.jpg";